import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'

export default class PriceTier extends Model {
  static name = 'PriceTier'

  static versioned = true

  static isConfiguration = true

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Concession]

  static level = MODEL_LEVEL.CIRCUIT

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      displayOrder: {
        type: Integer,
        default: 100
      }
    }
  }
}
